import gsap from 'gsap'

export default {
    name: 'work-list',
    leave(data) {
        let scrollPromise = new Promise(resolve => {
            resolve()
            // const scrollTo = new CustomEvent('scrollTo', { detail: { target: 'top', options: { duration: 250, disableLerp: true, callback: resolve } } });
            // window.dispatchEvent(scrollTo);
        })

        let animationPromise = gsap.to(data.current.container.querySelector('.c-work-list_list'), {
            duration: .25,
            opacity: 0.25
        })

        return Promise.all([scrollPromise,animationPromise]);
    },
    enter(data) {
        return gsap.from(data.next.container.querySelector('.c-work-list_list'), {
            duration: .25,
            opacity: 0.25
        })
    },
    from: {
        custom({trigger}) {
            return trigger && trigger.dataset && trigger.dataset.loadTransition == 'work-list';
        }
    }
}
